import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UserInputComponent } from '../user-input/user-input.component';

function numberAsDanishString(number: number, rounding: number | null) {
  if (number === undefined || number === null)
    return '';

  if (rounding)
    return `${number.toFixed(rounding)}`.replace(".", ",")

  return `${number}`.replace(".", ",")
}

@Component({
  selector: 'user-number',
  templateUrl: './user-number.component.html',
  styleUrls: ['./user-number.component.css']
})
export class UserNumberComponent {

  _value: number;

  @Input() set value(value: number) {
    this._value = value;
    
    setTimeout(() => {
      this.numberInputRef.value = numberAsDanishString(this._value, this.decimalPlaces);
    });
  }

  @Output() valueChange = new EventEmitter<number>();
  @Input() placeholder: string = '';
  @Input() decimalPlaces: number | null = null;
  @Input() label: string;
  @Input() required: {value: true, message: string};


  @ViewChild("numberInput") numberInputRef: UserInputComponent;


  setNumber(target: HTMLInputElement) {
    const numericValue = this.parseDecimalValue(target.value);
    target.value = numberAsDanishString(numericValue, this.decimalPlaces);
    this._value = numericValue;
    this.valueChange.emit(numericValue);
  }

  validateNumericCommaInput(event: KeyboardEvent) {
    const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', ','];
    const inputElement = event.target as HTMLInputElement;

    if (!allowedKeys.includes(event.key) && !event.ctrlKey)
        return event.preventDefault();

    if (event.key === ',' && inputElement.selectionStart === 0)
      return event.preventDefault();

    if (event.key === ',' && inputElement.value.includes(','))
        return event.preventDefault();
  }

  parseDecimalValue(value: string): number {
    return parseFloat(value.replace(',', '.'));
  }
}
